import { TenantClientListResponseInterface } from '@interfaces/Client.interface';
import BaseApiClient from '../BaseApiClient';
import { ListDataParams, ListDataResponse } from '../types';

export class ApiTenantClient extends BaseApiClient {
  async list(
    listData: ListDataParams,
    searchTerm?: string
  ): Promise<ListDataResponse<TenantClientListResponseInterface>> {
    return new Promise((resolve, reject) => {
      if (searchTerm) {
        if (!listData.filters) listData.filters = {};
        listData.filters.name = searchTerm;
      }
      this.client
        .getList('/me/client', listData)
        .then((res) => {
          if (res.data) {
            resolve({
              items: res.data.data,
              pagination: {
                page: res.data.meta?.page,
                perPage: res.data.meta?.per_page,
                total: res.data.meta?.total
              }
            });
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  async all(): Promise<Array<TenantClientListResponseInterface>> {
    return new Promise((resolve, reject) => {
      this.client
        .get('/me/client')
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export { tenantClientQueryKeys } from './query-keys';
export type { TenantClientListQueryParams } from './query-keys';
export { useTenantClientAllQuery, useTenantClientListQuery } from './use-tenant-client-queries';

